<template>
  <section class="stone">
    <div class="coords">
      <span>N</span><span>a</span><span>t</span><span>i</span><span>o</span><span>n</span>
      <span>&nbsp;</span><span>o</span><span>f</span><span>&nbsp;</span>
      <span>B</span><span>r</span><span>u</span><span>n</span><span>e</span><span>i</span>
      <br />
      <span>T</span><span>h</span><span>e</span>
      <span>&nbsp;</span><span>3</span><span>r</span><span>d</span><span>&nbsp;</span>
      <span>o</span><span>f</span><span>&nbsp;</span>
      <span>A</span><span>p</span><span>r</span><span>i</span><span>l</span>
      <br />
      <br />
      <span>L</span><span>a</span><span>t</span><span>i</span><span>t</span><span>u</span><span>d</span><span>e</span>
      <br />
      <span class="number">4</span>° <span class="number">5</span><span class="number">3</span>' <span class="number">1</span><span class="number">4</span>.<span class="number">9</span><span class="number">9</span>" N
      <br />
      <span>L</span><span>o</span><span>n</span><span>g</span><span>i</span><span>t</span><span>u</span><span>d</span><span>e</span>
      <br />
      <span class="number">1</span>1<span class="number">4</span>° <span class="number">5</span><span class="number">6</span>' <span class="number">1</span><span class="number">9</span>.<span class="number">9</span><span class="number">9</span>" E
    </div>

    <div class="text">
      The 3rd of April 2019, Brunei enacted strict laws against gay sex and adultery, following the Islamic Sharia,making those actions punishable with stoning to death.<br />Countries self-determination isn’t the topic here. The topic is that Basic Human Rights aren’t up for a country to choose.
    </div>
  </section>
</template>

<script>
import aion from '@/scripts/aion';
import animations from '@/assets/animations';
import { SplitText } from '@/assets/libs/SplitText';

export default {
  name: 'StoneSection',

  data() {
    return {
      split: null,
      coordsEntered: false,
      textEntered: false,
    };
  },

  mounted() {
    this.$eventHub.$on('font-loaded', () => {
      this.split = new SplitText(this.$el.querySelector('.text'));
    });
    aion.add(() => {
      if (
        this.$el.querySelector('.coords').getBoundingClientRect().top < window.innerHeight
        && !this.coordsEntered
      ) {
        this.coordsEntered = true;
        animations.get('coords-enter')(this.$el).play();
      }
      if (
        this.$el.querySelector('.text').getBoundingClientRect().top < window.innerHeight
        && !this.textEntered
      ) {
        this.textEntered = true;
        animations.get('text-enter')(this.split).play();
      }
    }, 'stone-enter');
  },
};
</script>

<style lang="scss" scoped>
.stone {
  position: relative;
  padding-bottom: 100%;

  @include mq($until: ipadL) {
    // padding-bottom: 110%;
    padding-bottom: 0%;
  }

  .coords {
    font-family: 'GT America Mono';
    font-size: rem(20px);
    line-height: rem(34px);
    position: absolute;
    top: 120px;
    right: 45%;

    @include mq($until: ipadP) {
      font-size: rem(18px);
      left: auto;
      right: 40px;
    }
  }

  .text {
    font-family: 'GT America Mono';
    font-size: rem(20px);
    line-height: rem(34px);
    position: absolute;
    bottom: -20px;
    left: 20%;
    width: 400px;

    @include mq($until: ipadL) {
      position: relative;
      width: 60%;
      left: auto;
      margin-left: auto;
      padding: 0px 60px;
      padding-top: 100%;
    }

    @include mq($until: ipadP) {
      width: 70%;
      left: 0px;
      right: auto;
      margin-left: auto;
      margin-right: auto;
      padding: 0px 25px;
      padding-top: 160%;
      font-size: rem(18px);
    }
  }
}
</style>
